import React from "react";
import styled from "styled-components";
import { rem } from "polished";

import { ReactComponent as Arrow } from "../../assets/img/arrow-down.svg";

const El = styled.label`
  display: block;
  width: ${rem(165)};
  margin-top: ${rem(10)};
  margin-bottom: ${rem(10)};
  position: relative;
`;

const ArrowContainer = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  width: ${rem(28)};
  height: 100%;
  border-left: 1px solid #aeb1b7;
  pointer-events: none;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

const StyledSelect = styled.select`
  appearance: none;
  background: linear-gradient(180deg, #f5f6f8 0%, #eeeff1 100%);
  border: 1px solid #aeb1b7;
  border-radius: 4px;
  height: ${rem(32)};
  padding: 0 ${rem(28)} 0 ${rem(8)};
  width: 100%;
  font-size: ${rem(13)};

  &:focus {
    outline: none;
  }
`;

const Select = ({
  value,
  onChange,
  isDisabled,
  options,
  liner,
  isOptionDisabled = () => false,
}) => {
  const selectedOption = options.find((option) => option.id === value);

  return (
    <El>
      <StyledSelect
        value={isOptionDisabled(selectedOption) ? options[0] : value}
        onChange={onChange}
        disabled={isDisabled}
      >
          {/*liner prop never passed to Checkbox across the app. So removed unused check logic.*/}
          {options.map((item) => (
              <option
                  key={item.id}
                  value={item.id}
                  disabled={isOptionDisabled(item)}
                  defaultValue={item.id}
              >
                  {item.label}
              </option>
          ))}
      </StyledSelect>

      <ArrowContainer>
        <Arrow />
      </ArrowContainer>
    </El>
  );
};

export default Select;
